<template>
  <Head title="Agency Results" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <agency-client-results :data_blend="data_blend" :agency="agency" :client="client"></agency-client-results>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  data_blend: Object,
  agency: Object,
  client: Object
});
</script>

